<template>
    <div :class="[outerClass, colSize]">
        <label v-if="label"
               class="block"
               :class="labelClass"
               :style="labelStyle">
            {{ __(label) }}
            <small v-if="showSizeInfo"
                   style="color: #666; font-size: 0.8em; display: block;">
                <span v-if="maxFileSize">{{ __('Max file size') }}: {{ formatFileSize(maxFileSize) }}</span>
                <span v-if="maxTotalSize">{{ __('Max total size') }}: {{ formatFileSize(maxTotalSize) }}</span>
            </small>
        </label>
        <FileUploader :category="category"
                      :disabled="isFormDisabled"
                      :disallowedExtensions="disallowedExtensions"
                      :allowedExtensions="allowedExtensions"
                      :maxFiles="maxFilesAsNumber"
                      :maxFileSize="maxFileSize"
                      :maxTotalSize="maxTotalSize"
                      :fieldName="fieldName"
                      :isShortNames="isShortNames"
                      :imgPosition="imgPosition"
                      :imgSize="imgSize"
                      v-model:files="field" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import FileUploader from '../Crud/FileUploader.vue'
import { __ } from '@pages/Helper/utils.js'

const props = defineProps({
    fieldName: {
        type: String,
        default: null
    },
    label: {
        type: String,
        default: null,
    },
    size: {
        type: String,
        default: null
    },
    isFormDisabled: {
        type: Boolean,
        default: false
    },
    isShortNames: {
        type: Boolean,
        default: false
    },
    category: {
        type: String,
        default: null
    },
    disallowedExtensions: {
        type: Array,
        default: []
    },
    allowedExtensions: {
        type: Array,
        default: []
    },
    maxFiles: {
        type: [Number, null],
        default: null
    },
    maxFileSize: {
        type: [Number, null],
        default: null
    },
    maxTotalSize: {
        type: [Number, null],
        default: null
    },
    showSizeInfo: {
        type: Boolean,
        default: true
    },
    labelClass: {
        type: String,
        default: null,
    },
    labelStyle: {
        type: String,
        default: null
    },
    inRepeater: {
        type: Boolean,
        default: false
    },
    imgPosition: {
        type: String,
        default: null
    },
    imgSize: {
        type: Number,
        default: 32
    }
});

const field = defineModel('field');
const colSize = props?.size ? 'col-' + props.size : 'col';
const maxFilesAsNumber = Number(props.maxFiles);
const outerClass = ref('field');

if (props.inRepeater) {
    outerClass.value = null;
}

// Funkcja formatowania rozmiaru pliku
const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

</script>

<style lang="scss" scoped></style>
